<template>
    <div class="col-md-12">
        <br />
        <form name="newDocument"
              class="form-horizontal form-label-left"
              @submit.prevent="handleSubmit()">
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Subject/Title :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="SubjectTitle"
                           v-validate="'required|max:255'"
                           v-model="encodingData.SubjectTitle"
                           id="SubjectTitle"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('SubjectTitle') }" />
                    <div v-if="submitted && errors.has('SubjectTitle')"
                         class="invalid-feedback">
                        {{ errors.first("SubjectTitle") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Report Number :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="ReportNo"
                           v-validate="'max:50'"
                           v-model="encodingData.ReportNo"
                           id="ReportNo"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('ReportNo') }" />
                    <div v-if="submitted && errors.has('ReportNo')"
                         class="invalid-feedback">
                        {{ errors.first("ReportNo") }}
                    </div>

                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Written By :</label>
                <div class="col-md-6 col-sm-6">
                    <input name="WrittenBy"
                           v-validate="'max:50'"
                           v-model="encodingData.WrittenBy"
                           class="form-control" />
                    <div v-if="submitted && errors.has('WrittenBy')"
                         class="invalid-feedback">
                        {{ errors.first("WrittenBy") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Report Date :</label>
                <div class="col-md-6 col-sm-6">
                    <input type="date"
                           v-validate="'required'"
                           name="ReportDate"
                           v-model="encodingData.ReportDate"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('ReportDate') }" />
                    <div v-if="submitted && errors.has('ReportDate')"
                         class="invalid-feedback">
                        {{ errors.first("ReportDate") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Source Office:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SourceId"
                            v-validate="'required'"
                            v-model="encodingData.SourceId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('SourceId') }">
                        <option value>Select Source</option>
                        <option v-for="option in sources"
                                v-bind:value="option.sourceID"
                                v-bind:key="option.sourceID">
                            {{ option.sourceName }}
                        </option>
                    </select>
                    <div v-if="submitted && errors.has('SourceId')"
                         class="invalid-feedback">
                        {{ errors.first("SourceId") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Info Accuracy:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="InfoAccId"
                            v-validate="'required'"
                            v-model="encodingData.InfoAccId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('InfoAccId') }">
                        <option value>Select Info Accuracy</option>
                        <option v-for="option in infoacc"
                                v-bind:value="option.infoAccID"
                                v-bind:key="option.infoAccID">
                            {{ option.infoAccDesc }}
                        </option>
                    </select>
                    <div v-if="submitted && errors.has('InfoAccId')"
                         class="invalid-feedback">
                        {{ errors.first("InfoAccId") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">File Upload :</label>
                <div class="col-md-6 col-sm-6">
                    <input v-validate="'required'"
                           type="file"
                           name="fileupload"
                           ref="file"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('fileupload') }"
                           v-on:change="handleFileUpload()" />
                </div>
                <div v-if="submitted && errors.has('fileupload')" class="invalid-feedback">
                    {{ errors.first("fileupload") }}
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Report Type:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="ReportType"
                            v-validate="'required'"
                            v-model="encodingData.ReportType"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('ReportType') }">
                        <option value>Select Report</option>
                        <option v-for="option in reports"
                                v-bind:value="option.reportID"
                                v-bind:key="option.reportID">
                            {{ option.reportName }}
                        </option>
                    </select>
                    <div v-if="submitted && errors.has('ReportType')"
                         class="invalid-feedback">
                        {{ errors.first("ReportType") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Origin Office:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="OriginId"
                            v-validate="'required'"
                            v-model="encodingData.OriginId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('OriginId') }">
                        <option value>Select Origin</option>
                        <option v-for="option in sources"
                                v-bind:value="option.sourceID"
                                v-bind:key="option.sourceID">
                            {{ option.sourceName }}
                        </option>
                    </select>
                    <div v-if="submitted && errors.has('OriginId')"
                         class="invalid-feedback">
                        {{ errors.first("OriginId") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Sec Class:</label>
                <div class="col-md-6 col-sm-6">
                    <select name="SecClassId"
                            v-validate="'required'"
                            v-model="encodingData.SecClassId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('SecClassId') }">
                        <option value>Select Sec Class</option>
                        <option value="0">NONE</option>
                        <option value="1">RESTRICTED</option>
                        <option value="2">CONFIDENTIAL</option>
                        <option value="3">SECRET</option>
                        <option value="4">TOP SECRET</option>
                    </select>
                    <div v-if="submitted && errors.has('SecClassId')"
                         class="invalid-feedback">
                        {{ errors.first("SecClassId") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">FullText :</label>
                <div class="col-md-6 col-sm-6">
                    <textarea name="FullText"
                              v-validate="'required|max:4000'"
                              v-model="encodingData.FullText"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && errors.has('FullText') }" />
                    <div v-if="submitted && errors.has('FullText')"
                         class="invalid-feedback">
                        {{ errors.first("FullText") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Major Classification :</label>
                <div class="col-md-6 col-sm-6">
                    <select name="Major"
                            v-validate="'required'"
                            v-model="encodingData.Major"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('Major') }">
                        <option value>Select Major Classification</option>
                        <option v-for="option in majorc"
                                v-bind:value="option.major"
                                v-bind:key="option.docClasID">
                            {{ option.major }}
                        </option>
                    </select>
                    <div v-if="submitted && errors.has('Major')"
                         class="invalid-feedback">
                        {{ errors.first("Major") }}
                    </div>
                </div>
            </div>
            <div class="item form-group">
                <label class="col-form-label col-md-3 col-sm-3 label-align">Minor Classification :</label>
                <div class="col-md-6 col-sm-6">
                    <select name="Minor"
                            v-model="encodingData.Minor"
                            class="form-control">
                        <option value>Select Minor Classification</option>
                        <option v-for="option in minorc"
                                v-bind:value="option.minor"
                                v-bind:key="option.docClasID">
                            {{ option.minor }}
                        </option>
                    </select>

                </div> 
            </div>
            
            <div class="ln_solid"></div>
            <div class="item form-group">
                <div class="col-md-6 col-sm-6">
                    <button type="submit" class="btn btn-primary">Save</button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        authHeaderPost,
        notifyHelper,
        EncodeURL,
        getlocalstorageSources,
        getlocalstorageInfoAcc,
        getLocalstorageMajorClassification,
        RecordURL,
    } from "../../helper";
    import instance from "../../helper/http";
    export default {
        data() {
            return {
                encodingData: {
                    DocumentId: "",
                    SubjectTitle: "",
                    ReportNo: "",
                    WrittenBy: "",
                    ReportDate: "",
                    SourceId: "",
                    InfoAccId: "",
                    ReportType: "",
                    SecClassId: "",
                    OriginId: "",
                    FullText: "",
                    FileName: "",
                    Major: "",
                    Minor: ""
                    
                },
                sources: [],
                infoacc: [],
                reports: [],
                majorc: [],
                minorc: [],
                submitted: false,
                file: "",
            };
        },
        created: function () {
            this.getSources();
        },
        watch: {
            "encodingData.SourceId": function (id) {
                this.SourceChange(id);
            },
            "encodingData.Major": function (Major) {
                this.MajorChange(Major);
            }
        },
        methods: {
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
                if (this.file.size > 21966080) {
                    notifyHelper("warn", "file size limit reach. Max of 20MB only")
                    this.file = "";
                    return;
                }
            },
            handleSubmit() {
                this.submitted = true;

                this.$validator.validate().then((valid) => {
                    if (this.file.size > 21966080) {
                        notifyHelper("warn", "file size limit reach. Max of 20MB only")
                        this.file = "";
                        return;
                    }
                    if (valid) {
                        instance
                            .get(
                                EncodeURL +
                                "reportnumber?reportNumber=" +
                                this.encodingData.ReportNo,
                                {
                                    headers: authHeader(),
                                }
                            )
                            .then((response) => {
                                if (response.data.duplicate) {
                                    notifyHelper("info", "Duplicate report number");
                                } else {
                                    this.postEncode();
                                }
                            })
                            .catch(function (error) {
                                responseCheck(error.response.status);
                            });
                    }
                });
            },
            postEncode() {
                let loader = this.$loading.show();
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("DocumentDetails", JSON.stringify(this.encodingData));
                instance
                    .post(EncodeURL + "new", formData, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.error) {
                            loader.hide();
                            notifyHelper("error", response.data.message);
                        } else {
                            loader.hide();
                            notifyHelper("success", "Document Updated");
                            //this.clearControls()
                            if (confirm("Active link mode?"))
                                this.$store.commit("enablelinkMode", {
                                    id: response.data.id,
                                    type: "DC",
                                    description: this.encodingData.SubjectTitle,
                                });
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        responseCheck(error.response.status);
                    });
            },
            processSave() {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("DocumentDetails", this.encodingData);
                let loader = this.$loading.show();
                instance
                    .post(EncodeURL + "upload", formData, {
                        headers: authHeaderPost(),
                    })
                    .then((response) => {
                        if (response.data.error) {
                            loader.hide();
                            notifyHelper("error", response.data.message);
                        } else {
                            if (typeof response.data.withid !== "undefined") {
                                if (typeof response.data.unreachable !== "undefined") {
                                    loader.hide();
                                    if (
                                        confirm(
                                            "File server is unreachable! save the document info instead?"
                                        )
                                    )
                                        this.postEncode(response.data.id, false);
                                } else {
                                    loader.hide();
                                    this.postEncode(response.data.id, false);
                                }
                            } else {
                                loader.hide();
                                this.postEncode(response.data.id, true);
                            }
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getSources() {
                this.sources = getlocalstorageSources();
                this.infoacc = getlocalstorageInfoAcc();
                this.majorc = getLocalstorageMajorClassification();
            },
            clearControls() {
                this.encodingData.DocumentId = "";
                this.encodingData.SubjectTitle = "";
                this.encodingData.ReportNo = "";
                this.encodingData.WrittenBy = "";
                this.encodingData.ReportDate = "";
                this.encodingData.InfoAccId = "";
                this.encodingData.FullText = "";
                this.file = "";
                this.encodingData.ReportType = "";
                this.encodingData.Major = "";
                this.encodingData.Minor = "";
                this.encodingData.SecClassId = "";
                this.encodingData.FileName = "";
            },
            SourceChange(id) {
                instance
                    .get(RecordURL + "reportid?id=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.reports = response.data;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            MajorChange(Major) {
                instance
                    .get(EncodeURL + "MinorClassification?Major=" + Major, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.minorc = response.data.data;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
        },
    };
</script>

